import './raphael';
require('morris.js/morris.min');

import { Accounts } from './src/accounts';

$(document).ready(function() {
  Accounts.setup();
});
